import { InvoicesIndexScreen } from 'src/pages/invoices';
import { InventorySaleInvoiceListScreen } from 'src/pages/invoices/inventory-sale';
import { InventorySaleInvoiceDetailScreen } from 'src/pages/invoices/inventory-sale/detail';
import { PlatformFeeInvoiceListScreen } from 'src/pages/invoices/platform-fee';
import { PlatformFeeInvoiceDetailScreen } from 'src/pages/invoices/platform-fee/detail';
import { FblDeliveryInvoiceListScreen } from 'src/pages/invoices/fbl-delivery';
import { FblDeliveryInvoiceDetailScreen } from 'src/pages/invoices/fbl-delivery/detail';
import { GeneralDeliveryInvoiceListScreen } from 'src/pages/invoices/general-delivery';
import { GeneralDeliveryInvoiceDetailScreen } from 'src/pages/invoices/general-delivery/detail';

export const InvoiceRoutes = [
  { path: '/invoices', exact: true, component: InvoicesIndexScreen },
  { path: '/invoices/inventory-sale', exact: true, component: InventorySaleInvoiceListScreen },
  { path: '/invoices/inventory-sale/:invoiceNo', exact: true, component: InventorySaleInvoiceDetailScreen },
  { path: '/invoices/platform-fee', exact: true, component: PlatformFeeInvoiceListScreen },
  { path: '/invoices/platform-fee/:invoiceNo', exact: true, component: PlatformFeeInvoiceDetailScreen },
  { path: '/invoices/fbl-delivery', exact: true, component: FblDeliveryInvoiceListScreen },
  { path: '/invoices/fbl-delivery/:invoiceNo', exact: true, component: FblDeliveryInvoiceDetailScreen },
  { path: '/invoices/general-delivery', exact: true, component: GeneralDeliveryInvoiceListScreen },
  { path: '/invoices/general-delivery/:invoiceNo', exact: true, component: GeneralDeliveryInvoiceDetailScreen },
];
